import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Wordmark from './Wordmark';
import Footer from './Footer';
import { useAuth } from '../lib/useAuth';

interface AppShellProps {
  children: ReactNode;
  /** Right-hand slot in the header: sign in, project name, admin nav. */
  action?: ReactNode;
}

export default function AppShell({ children, action }: AppShellProps) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main"
        className="sr-only rounded-full bg-green-600 px-5 text-white focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-50 focus:inline-flex focus:min-h-tap focus:items-center"
      >
        Skip to content
      </a>

      <header className="sticky top-0 z-30 border-b border-grey-200 bg-white/92 backdrop-blur-[14px] backdrop-saturate-[1.8]">
        <div className="mx-auto flex min-h-header w-full max-w-wrap items-center justify-between gap-4 px-gutter">
          <Link to="/" className="inline-flex min-h-tap items-center rounded-sm">
            <Wordmark />
          </Link>
          <div className="flex items-center gap-4">
            {action}
            {user && (
              <button
                type="button"
                onClick={async () => {
                  await signOut();
                  navigate('/');
                }}
                className="t-meta min-h-tap hidden items-center font-semibold text-green-700 underline decoration-1 underline-offset-4 sm:inline-flex"
              >
                Sign out
              </button>
            )}
          </div>
        </div>
      </header>

      <main id="main" className="mx-auto w-full max-w-wrap flex-1 px-gutter py-12 sm:py-16">
        {children}
      </main>

      <Footer />
    </div>
  );
}
